function appmode() {

    var footer = getUrlParam('footer');
    var app = getUrlParam('app');
    var meter = getUrlParam('meter');

    if (app) {
        $('#header').remove();
        $('#footer').remove();
        $('#tl').remove();

        //document.getElementById('footer').style.display = 'none';
        document.getElementById('main').style.paddingTop = '0px';

        $('a').each(function(){
            var curURL = $(this).attr('href');
            var newURL = curURL + '?app=1';

            if (  $(this).attr('target') != '_blank' ) {
                if (! $(this).hasClass('noapp') ) {
                    $(this).attr('href', newURL);
                }
            }

        })

    }

    if (footer) {
        $('#footer').remove();
    }

    if (meter) {
        $('.ticket-meter').remove();
    }
};
